import { Campaign } from "clearline-api";
import { LocationWidgetSettings } from "../models/location-widget-settings";

// todo: migrate to LocationWithDefaultWidgetGetDto
/** @deprecated use/migrate LocationWithDefaultWidgetGetDto */
export interface CustomizedCampaign extends Campaign {
  disabled: boolean;
  sortIndex: number;
  locationWidgetSettings: LocationWidgetSettings;
}
